<template>
  <el-dialog
    :visible.sync="isShow"
    :title="title"
    @dragDialog="handleDrag"
    @close="close"
    top="10vh"
    :append-to-body="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    width="70%"
    class="previewPDF"
    append-to-body
  >
    <!--内容-->
    <iframe :src="pdfUrlMounted" style="width: 100%;height: 95%" frameborder="no"></iframe>
  </el-dialog>
</template>

<script>
export default {
  name: 'previewPDF',
  props: {
    // 是否显示弹层
    show: {
      type: Boolean,
      default: false,
    },
    // 弹层title
    title: {
      type: String,
      default: '预览',
    },
    // pdfUrl后台返回流路径，必填
    pdfUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 不直接修改show，单项数据流问题
      isShow: false,
      pdfUrlMounted: '',
    };
  },
  mounted() {
    this.pdfUrlMounted = this.pdfUrl;
  },
  watch: {
    show(val) {
      if (val) {
        this.isShow = val;
      }
    },
    pdfUrl() {
      this.pdfUrlMounted = this.pdfUrl;
    },
  },
  methods: {
    handleDrag() {},
    close() {
      this.$emit('update:show', this.isShow);
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.previewPDF {
  height: 100%;

  .el-dialog {
    height: 80%;

    .el-dialog__body {
      height: calc(100% - 54px);
      overflow-y: auto;
    }
  }
}
</style>
